import { Component, Input, OnInit } from '@angular/core';
import { AesRequestModel } from '@core/models/AesRequest.model';
import { Tag } from '@core/models/Tag';
import { ApiService } from '@core/services/api/api.service';
import { LibraryService } from '@core/services/library/library.service';
import { ModalService } from '@core/services/modal/modal.service';
import { ClinicQuery } from '@state/clinic/clinic.query';

@Component({
    selector: 'app-appointment-edit-tags',
    templateUrl: './appointment-edit-tags.modal.html',
    styleUrls: ['./appointment-edit-tags.modal.scss'],
    standalone: false
})
export class AppointmentEditTagsModal implements OnInit {
    @Input() tags: Tag[];
    @Input() id: string;
    @Input() diaryGID: string;
    @Input() isConfirmed: string;

    title = this.libraryService.getLabel('lbl_tag_selector');
    selectedTags: Set<Tag> = new Set();
    tagsList: Tag[] = [];

    constructor(
        private clinicQuery: ClinicQuery,
        private libraryService: LibraryService,
        private modalService: ModalService,
        private apiService: ApiService
    ) {
    }

    ngOnInit(): void {
        this.selectedTags = new Set(this.tags);
        this.tagsList = this.clinicQuery.getActive().tags.filter(({ id }) => parseInt(id, 10) > 0);
    }

    selectTag(tag: Tag, $event: MouseEvent): void {
        $event.preventDefault();
        $event.cancelBubble = true;

        if(!tag.enabled && this.isConfirmed) {
            return;
        }

        if (this.isTagSelected(tag)) {
            this.selectedTags.delete(tag);
            this.saveTag(tag.id, false);
        } else {
            this.selectedTags.add(tag);
            this.saveTag(tag.id, true);
        }
    }

    isTagChecked(tag: Tag): boolean {
        return this.isTagSelected(tag);
    }

    closeModal(): void {
        this.modalService.dismiss({ tags: Array.from(this.selectedTags) }, 'close', this.id);
    }

    saveTag(tagID: string, isChecked: boolean) {
        const form = new AesRequestModel('SEC_APP_TAG_SAVE_FORM', [
            {
                Param: 'Json',
                Value: JSON.stringify({
                    DiaryGID: this.diaryGID,
                    TagID: tagID,
                    TagChecked: isChecked ? '-1' : '0',
                }),
                AESIndex: '1'
            }
        ], 0);

        this.apiService.callApiObservable(form).subscribe( e => {

        });
    }


    private isTagSelected(tag: Tag): boolean {
        return Array.from(this.selectedTags).map(({ id }) => id).includes(tag.id);
    }
}
